/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Fila opcional de precio definitivo por medida
*      3       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Scroll horizontal de medidas con columnas fijas
*      4       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Amplía fuente de precios definitivos
*      5       | 03/06/2026 | Lic. José Luis Aragón Cervantes  | Amplía fuente de existencias por talla
*      6       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Modo sin paginado para existencias
*      7       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Mayor lectura en columnas de medidas
*      8       | 13/08/2026 | Lic. José Luis Aragón Cervantes  | Seguimiento de foco en buscadores sin paginado
 *      9       | 26/08/2026 | Lic. José Luis Aragón Cervantes  | Fija descripción junto a clave y agrega acción opcional
 *      10      | 30/08/2026 | Lic. José Luis Aragón Cervantes  | Ancho fijo amplio de columna descripción para portétil
 *      11      | 18/09/2026 | LIC. José Luis Aragón C.                       | Modo portétil: clave+descripción con scroll, solo totales fijo
 *      12      | 18/09/2026 | LIC. José Luis Aragón C.                       | Portada funcionalidad de original: descripcionFija, showClaveColumn, headerExtra
 * ---------------------------------------------------------------------------------------
 */

import TextField from "../ui/TextField";
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess"

import { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, IconButton, Typography, Paper, Box, Grid, Button } from "@mui/material";

import Tooltip from "@mui/material/Tooltip";

import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import { useLayout } from "../../context/System/LayoutContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useConfiguracion } from "../../context/System/ConfiguracionContext";
import { isNullOrEmpty } from "../../settings/utils";

import SearchIcon from "@mui/icons-material/Search";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import PropTypes from "prop-types";
import { CardTravelSharp } from "@mui/icons-material";

export default function SizeSoftXTableExistencias({
    data,
    columns,
    id,
    row={},
    setRow,
    defaultRow,
    disableStickyHeader,
    fontSize = "medium",
    rowSpacing = 1,
    rowsPerPageIntro = 6,
    activaProgress,
    setClave,
    setMedida,
    onRowDoubleClick,
    onEnterKey,
    mostrarPrecioDefinitivo = false,
    disablePagination = false,
    fillContainer = false,
    onActionClick,
    disableStickyStartColumns = false,
    showClaveColumn = true,
    descripcionFija = true,
}) 
{    
    const pager = [3, 6, 10, 20, 50];
    // Funcionalidad portada de original: permite ocultar la columna clave y
    // configurar si la descripción va fija o con scroll.
    const visibleColumns = useMemo(() => {
        if (showClaveColumn) return columns;
        return columns.filter(c => c.field !== "clavearticulo");
    }, [columns, showClaveColumn]);
    const firstColumnWidth = 180;
    const descriptionColumnWidth = 400;
    const showActionButton = typeof onActionClick === "function";
    const stickyFirstColumnSx = {
        position: "sticky",
        left: 0,
        zIndex: 3,
        minWidth: `${firstColumnWidth}px`,
        width: `${firstColumnWidth}px`,
        maxWidth: `${firstColumnWidth}px`,
        backgroundColor: "#fff",
        boxShadow: "3px 0 6px rgba(0, 0, 0, 0.08)",
    };
    const stickyFirstHeaderSx = {
        ...stickyFirstColumnSx,
        zIndex: 6,
        backgroundColor: "#fff",
    };
    const stickyDescriptionColumnSx = (descripcionFija && !disableStickyStartColumns) ? {
        position: "sticky",
        left: visibleColumns[0]?.field === "clavearticulo" ? `${firstColumnWidth}px` : "0px",
        zIndex: 3,
        minWidth: `${descriptionColumnWidth}px`,
        width: `${descriptionColumnWidth}px`,
        maxWidth: `${descriptionColumnWidth}px`,
        backgroundColor: "#fff",
        boxShadow: "3px 0 6px rgba(0, 0, 0, 0.08)",
    } : {};
    const stickyDescriptionHeaderSx = (descripcionFija && !disableStickyStartColumns) ? {
        ...stickyDescriptionColumnSx,
        zIndex: 6,
    } : {};
    const stickyTotalColumnSx = {
        position: "sticky",
        right: 0,
        zIndex: 3,
        padding: "2px 2px",
        fontSize: "0.75rem",
        minWidth: "58px",
        maxWidth: "74px",
        whiteSpace: "nowrap",
        fontWeight: "bold",
        backgroundColor: "#e3f2fd",
        boxShadow: "-3px 0 6px rgba(0, 0, 0, 0.08)",
    };
    const stickyTotalHeaderSx = {
        ...stickyTotalColumnSx,
        zIndex: 6,
    };
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageIntro);
    const [dataRows, setDataRows] = useState(data);
    const [orderBy, setOrderBy] = useState("");
    const [order, setOrder] = useState(true);
    const [cargando, setCargando] = useState(false);
    const tableRef = useRef(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);

    const { tablaReferencia } = useLayout();

    const {
        setPaginadoModel,
        getPaginadoModel,
        paginadoModel
    } = useConfiguracion();

    // Extraer todas las tallas únicas ordenadas - ordenar correctamente 22, 22.5, 23, 23.5...
    const tallas = Array.from(
        new Set(
            (data || []) // Asegurarnos de que data no sea null o undefined
                .flatMap(a => (a.listamedidas || []) // Asegurarnos de que listamedidas no sea null o undefined
                    .map(e => e.medida) // Obtener las tallas individuales
                )
        )
    ).sort((a, b) => parseFloat(a) - parseFloat(b));

    // Función para ordenar columnas
    const handleClickOrder = (field) => {
        const isAsc = orderBy === field && order;
        const newOrder = !isAsc;

        const sortedData = [...dataRows].sort((a, b) => {
            let valueA = a[field] || "";
            let valueB = b[field] || "";

            return typeof valueA === "string" 
                ? newOrder ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
                : newOrder ? valueA - valueB : valueB - valueA;
        });

        setDataRows(sortedData);
        setOrder(newOrder);
        setOrderBy(field);
    };

    // Función de cambio de pégina
    const handleChangePage = (_, newPage) => setPage(newPage);

    // Función para cambiar registros por pégina
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Función para selección de filas
    const handleClickRow = (valueRow) => () => {
        try {
            if (!valueRow?.clavearticulo) return;

            setRow(valueRow);
            setClave(valueRow.clavearticulo);
        } catch {
            return;
        }
    };

    // Actualización de datos si cambian
    useEffect(() => {
        setDataRows(data);
        setPage(0);
    }, [data]);

    useEffect(() =>{
        setRowsPerPage(rowsPerPageIntro)
    },[rowsPerPageIntro]);

    useEffect(() => {
        setCargando(activaProgress)
    },[activaProgress]);

    useEffect(() => {
        setSelectedIndex(-1);
    }, [data]);

    useEffect(() => {
        const container = tableRef.current;
        if (container) {
            container.focus();
        }
    }, []);

    useEffect(() => {
        if (row && dataRows.length > 0) {
            const rowIndex = dataRows.findIndex(r => r[id] === row[id]);
            if (rowIndex >= 0) {
                if (!disablePagination) {
                    const newPage = Math.floor(rowIndex / rowsPerPage);
                    if (newPage !== page) {
                        setPage(newPage);
                    }
                    setSelectedIndex(rowIndex % rowsPerPage);
                    return;
                }
                setSelectedIndex(rowIndex);
            }
        }
    }, [row, dataRows, id, rowsPerPage, page, disablePagination]);

    const getCurrentPageData = () => {
        if (disablePagination) return dataRows;
        const start = page * rowsPerPage;
        const end = Math.min(start + rowsPerPage, dataRows.length);
        return dataRows.slice(start, end);
    };

    // 18/09/2026 | En portétil clave+descripción van con scroll junto a las
    // medidas; solo la columna de totales queda fija a la derecha.
    // (descripcionFija replica el control de original.)
    const fixedColumnsWidth = (disableStickyStartColumns ? 0 : firstColumnWidth) + ((descripcionFija && !disableStickyStartColumns) ? descriptionColumnWidth : 0) + 74;

    const scrollSelectedRowIntoView = useCallback((index) => {
        const container = tableRef.current;
        if (!container || index < 0) return;

        window.requestAnimationFrame(() => {
            const selectedRow = container.querySelector(`[data-table-row-index="${index}"]`);
            if (!selectedRow) return;

            const margen = 56;
            const rowTop = selectedRow.offsetTop;
            const rowBottom = rowTop + selectedRow.offsetHeight;
            const visibleTop = container.scrollTop;
            const visibleBottom = visibleTop + container.clientHeight;

            if (rowBottom + margen > visibleBottom) {
                container.scrollTop = Math.max(rowBottom - container.clientHeight + margen, 0);
                return;
            }

            if (rowTop - margen < visibleTop) {
                container.scrollTop = Math.max(rowTop - margen, 0);
            }
        });
    }, []);

    const handleKeyDown = useCallback((e) => {
        if (!dataRows.length) return;
        
        const currentPageData = getCurrentPageData();
        const maxIndex = currentPageData.length - 1;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const currentIndex = selectedIndex >= 0 ? selectedIndex : -1;
            if (currentIndex < maxIndex) {
                const newIndex = currentIndex + 1;
                setSelectedIndex(newIndex);
                const newRow = currentPageData[newIndex];
                setRow(newRow);
                setClave(newRow?.clavearticulo);
                scrollSelectedRowIntoView(newIndex);
            } else if (!disablePagination && page < Math.ceil(dataRows.length / rowsPerPage) - 1) {
                setPage(page + 1);
                setSelectedIndex(0);
                const newRow = dataRows[(page + 1) * rowsPerPage];
                setRow(newRow);
                setClave(newRow?.clavearticulo);
                scrollSelectedRowIntoView(0);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const currentIndex = selectedIndex >= 0 ? selectedIndex : 0;
            if (currentIndex > 0) {
                const newIndex = currentIndex - 1;
                setSelectedIndex(newIndex);
                const newRow = currentPageData[newIndex];
                setRow(newRow);
                setClave(newRow?.clavearticulo);
                scrollSelectedRowIntoView(newIndex);
            } else if (!disablePagination && page > 0) {
                setPage(page - 1);
                const prevPageStart = (page - 1) * rowsPerPage;
                const prevPageEnd = Math.min(prevPageStart + rowsPerPage, dataRows.length);
                setSelectedIndex(prevPageEnd - prevPageStart - 1);
                const newRow = dataRows[prevPageEnd - 1];
                setRow(newRow);
                setClave(newRow?.clavearticulo);
                scrollSelectedRowIntoView(prevPageEnd - prevPageStart - 1);
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            let selectedRow = null;
            if (selectedIndex >= 0 && selectedIndex <= maxIndex) {
                selectedRow = currentPageData[selectedIndex];
            } else if (row && dataRows.length > 0) {
                selectedRow = row;
            }
            if (selectedRow) {
                setRow(selectedRow);
                setClave(selectedRow?.clavearticulo);
                onEnterKey?.(selectedRow);
            }
        }
    }, [selectedIndex, page, rowsPerPage, dataRows, row, setRow, setClave, scrollSelectedRowIntoView]);

    useEffect(() => {
        const container = tableRef.current;
        if (!container) return;
        
        container.tabIndex = 0;
        const handleKey = (e) => handleKeyDown(e);
        container.addEventListener('keydown', handleKey);
        return () => container.removeEventListener('keydown', handleKey);
    }, [handleKeyDown]);

    return (
        <Fragment>
            <TableContainer
                component={Paper}
                ref={tableRef}
                sx={{
                    maxWidth: "100%",
                    overflowX: "auto",
                    ...(fillContainer ? {
                        flex: 1,
                        minHeight: 0,
                        height: "100%",
                        maxHeight: "100%",
                        overflowY: "auto",
                    } : {}),
                }}
            >
                <Typography variant="h6" sx={{ m: .5 }}>Existencias por Talla</Typography>
                <Table
                    size="small"
                    ref={tablaReferencia}                        
                    stickyHeader={!disableStickyHeader}
                    className="SizeSoftX-table"
                    sx={{
                        tableLayout: "auto",
                        minWidth: tallas.length > 8 ? `${fixedColumnsWidth + (tallas.length * 70)}px` : "100%",
                    }}
                >
                    <TableHead>
                        <TableRow>
                            {visibleColumns.map((column, index) => (
                                <TableCell
                                    key={index}
                                    sx={
                                        disableStickyStartColumns
                                            ? undefined
                                            : column.field === "clavearticulo"
                                                ? stickyFirstHeaderSx
                                                : column.field === "descripcion"
                                                    ? {
                                                        ...stickyDescriptionHeaderSx,
                                                        ...((descripcionFija && !disableStickyStartColumns) ? {} : column.width ? { width: column.width, minWidth: column.width } : {}),
                                                    }
                                                    : undefined
                                    }
                                >
                                    {!column.hideSort ? (
                                        <Button
                                            variant="text" 
                                            onClick={() => handleClickOrder(column.field)}
                                            startIcon={orderBy === column.field ? (order ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />) : null}
                                            sx={{ m: -2 }}
                                        >
                                            {column.title}
                                        </Button>
                                    ) : column.title}
                                    {column.headerExtra && <span style={{ marginLeft: 4 }}>{column.headerExtra}</span>}
                                </TableCell>
                            ))}
                            {tallas.map((talla) => (
                                <TableCell
                                    key={talla}
                                    align="center"
                                    sx={{
                                        padding: "2px 2px",
                                        fontSize: "1.44rem",
                                        fontWeight: 700,
                                        lineHeight: 1.05,
                                        minWidth: "30px",
                                        maxWidth: "60px",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {talla}
                            </TableCell>
                            ))}
                            <TableCell
                                align="center"
                                sx={stickyTotalHeaderSx}
                            >
                                Total
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {getCurrentPageData().map((articulo, index) => (
                            <Fragment key={articulo[id]}>
                                <TableRow
                                    data-table-row-index={index}
                                    onClick={handleClickRow(articulo)}
                                    onDoubleClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (!articulo?.clavearticulo) return;

                                        setRow(articulo);
                                        setClave(articulo.clavearticulo);

                                        onRowDoubleClick?.(articulo);
                                    }}
                                    className={row && (row === articulo.clavearticulo || row[id] === articulo[id]) ? "row" : "no-row"}
                                    style={{ height: 6 + rowSpacing, fontSize, cursor: 'pointer' }}
                                >
                                    {visibleColumns.map((column, index) => (
                                        <TableCell
                                            key={index}
                                            sx={
                                                disableStickyStartColumns
                                                    ? {
                                                        ...(column.field === "descripcion" && column.width ? { width: column.width, minWidth: column.width } : {}),
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                    }
                                                    : column.field === "clavearticulo"
                                                        ? {
                                                        ...stickyFirstColumnSx,
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                    }
                                                    : column.field === "descripcion" ? {
                                                        ...stickyDescriptionColumnSx,
                                                        ...((descripcionFija && !disableStickyStartColumns) ? {} : column.width ? { width: column.width, minWidth: column.width } : {}),
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                    } : {
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'break-word',
                                                    }
                                            }
                                        >
                                            {column.field === "descripcion" ? (
                                                <Tooltip
                                                    title={
                                                        articulo.foto ? (
                                                            <div style={{ padding: 8, textAlign: 'center', backgroundColor: '#fff', borderRadius: 8 }}>
                                                                <img
                                                                    src={articulo.foto.startsWith('data:') ? articulo.foto : `${process.env.PUBLIC_URL}${articulo.foto}`}
                                                                    alt={articulo.descripcion}
                                                                    style={{
                                                                        width: 150,
                                                                        height: 150,
                                                                        objectFit: 'contain',
                                                                        borderRadius: 8,
                                                                        border: '1px solid #ccc'
                                                                    }}
                                                                    onError={(e) => {
                                                                        e.target.src = `${process.env.PUBLIC_URL}/recursos/no-image.png`;
                                                                    }}
                                                                />
                                                                <div style={{ marginTop: 8, fontSize: 14, fontWeight: 'bold', color: '#333' }}>
                                                                    {articulo.descripcion?.trim()}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div style={{ padding: 8, fontSize: 12 }}>
                                                                Sin foto disponible
                                                            </div>
                                                        )
                                                    }
                                                    placement="right"
                                                    arrow
                                                    enterDelay={500}
                                                >
                                                    <span style={{ cursor: 'pointer' }}>
                                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
                                                            {showActionButton && (
                                                                <Tooltip title="Ver costos en verificador">
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            e.stopPropagation();
                                                                            if (!articulo?.clavearticulo) return;

                                                                            setRow(articulo);
                                                                            setClave(articulo.clavearticulo);
                                                                            onActionClick(articulo);
                                                                        }}
                                                                        sx={{ flex: "0 0 auto" }}
                                                                    >
                                                                        <PriceCheckIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            <span style={{ minWidth: 0, overflowWrap: "anywhere" }}>
                                                                {column.render ? column.render(articulo) : articulo[column.field]}
                                                            </span>
                                                        </Box>
                                                    </span>
                                                </Tooltip>
                                            ) : (
                                                column.render ? column.render(articulo) : articulo[column.field]
                                            )}
                                        </TableCell>
                                    ))}
                                    {tallas.map((talla) => {
                                        const registro = (articulo.listamedidas || []).find(m => m.medida === talla);
                                        return (
                                            <TableCell
                                                key={talla}
                                                align="center"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (!articulo?.clavearticulo) return;

                                                    setRow(articulo);
                                                    setClave(articulo.clavearticulo);
                                                    setMedida(talla);
                                                }}
                                                onDoubleClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    if (!articulo?.clavearticulo) return;

                                                    setRow(articulo);
                                                    setClave(articulo.clavearticulo);
                                                    setMedida(talla);

                                                    onRowDoubleClick?.(articulo, talla);
                                                }}
                                                sx={{
                                                    padding: "3px 3px",
                                                    fontSize: "1.44rem",
                                                    lineHeight: 1.05,
                                                    fontWeight: 700,
                                                    minWidth: "70px",
                                                    maxWidth: "100px",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {registro ? (registro.existencia === 0 ? "👎" : registro.existencia) : "🔴"}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell
                                        align="center"
                                        sx={stickyTotalColumnSx}
                                    >
                                        {(articulo.listamedidas || []).reduce((acc, m) => acc + (m.existencia || 0), 0)}
                                    </TableCell>
                                </TableRow>
                                {mostrarPrecioDefinitivo && (
                                    <TableRow>
                                        {visibleColumns.map((column, index) => (
                                            <TableCell
                                                key={`precio-${index}`}
                                                sx={{
                                                    ...(column.field === "clavearticulo" && !disableStickyStartColumns ? {
                                                        position: "sticky",
                                                        left: 0,
                                                        zIndex: 3,
                                                        minWidth: "140px",
                                                        maxWidth: "180px",
                                                        boxShadow: "3px 0 6px rgba(0, 0, 0, 0.08)",
                                                    } : {}),
                                                    ...(column.field === "descripcion" && !disableStickyStartColumns && descripcionFija ? stickyDescriptionColumnSx : {}),
                                                    padding: "3px 6px",
                                                    fontSize: "1.44rem",
                                                    lineHeight: 1.05,
                                                    fontWeight: 700,
                                                    color: "primary.main",
                                                    backgroundColor: "#f8fbff",
                                                }}
                                            >
                                                {index === 0 ? "Precio definitivo" : ""}
                                            </TableCell>
                                        ))}
                                        {tallas.map((talla) => {
                                            const registro = (articulo.listamedidas || []).find(m => m.medida === talla);
                                            return (
                                                <TableCell
                                                    key={`precio-${talla}`}
                                                    align="center"
                                                    sx={{
                                                        padding: "3px 3px",
                                                        fontSize: "1.44rem",
                                                        lineHeight: 1.05,
                                                        minWidth: "70px",
                                                        maxWidth: "100px",
                                                        whiteSpace: "nowrap",
                                                        color: "primary.main",
                                                        fontWeight: 700,
                                                        backgroundColor: "#f8fbff",
                                                    }}
                                                >
                                                    {registro ? `$${Number(registro.preciodefinitivo || 0).toFixed(2)}` : ""}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell
                                            align="center"
                                            sx={{
                                                position: "sticky",
                                                right: 0,
                                                zIndex: 3,
                                                padding: "2px 2px",
                                                fontSize: "1.44rem",
                                                lineHeight: 1.05,
                                                backgroundColor: "#f8fbff",
                                                boxShadow: "-3px 0 6px rgba(0, 0, 0, 0.08)",
                                            }}
                                        />
                                    </TableRow>
                                )}
                            </Fragment>
                        ))}
                    </TableBody>
                </Table>
                <SizeSoftXLoadingProcess
                    open={cargando} message="Procesando información, por favor espere..." 
                />
                {!disablePagination && (
                    <TablePagination
                        component="div"
                        count={dataRows.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={pager}
                        labelRowsPerPage="Registros por pégina"
                    />
                )}
            </TableContainer>
        </Fragment>
    );
}

SizeSoftXTableExistencias.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    row: PropTypes.object,
    setRow: PropTypes.func.isRequired,
    rowsPerPageIntro: PropTypes.number,
    mostrarPrecioDefinitivo: PropTypes.bool,
    disablePagination: PropTypes.bool,
    fillContainer: PropTypes.bool,
    disableStickyStartColumns: PropTypes.bool,
    showClaveColumn: PropTypes.bool,
    descripcionFija: PropTypes.bool,
    onActionClick: PropTypes.func
};
